import { GQLIdEncoder } from '../../common/utils/GQLIdEncoder';
import { User } from '../models/User';
import { isAqueductEnabled } from '../../auth/utils';

export class UserMapper {
  private readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): User {
    // User ID may not be a number in AQueduct
    const useAqueduct = isAqueductEnabled();
    return new User(
      useAqueduct ? data.id : this.gqlIdEncoder.decode(data.id),
      data.name,
      data.preferredName,
      data.level,
      data.roles,
      data.origin,
      data.organization.id
    );
  }
}
